import script from "./NotLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./NotLogin.vue?vue&type=script&setup=true&lang=js"

import "./NotLogin.vue?vue&type=style&index=0&id=273b7ebf&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-273b7ebf"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSeparator});
